export const environment = {
  appVersion: require('../../package.json').version,
  enableServiceWorker: true,
  enableProdMode: true,
  enableDesktopMode: false,
  remoteApi: 'https://api.music-work.com/remote',
  apiVersion: 'v1',
  apiPath: '',
  urlPlaybackMedia: 'https://api.music-work.com/remote/v1/media/listen/'
};
